"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebMessengerController = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _components = require("../components");
var _constants = require("../constants");
var _constantsGenerated = require("../constants-generated");
var _contexts = require("../contexts");
var _webMessengerContext = require("../contexts/webMessengerContext");
var _logger2 = require("../logger");
var _ApiProvider = require("./ApiProvider");
var _jsxRuntime = require("react/jsx-runtime");
// istanbul ignore file @preserve -- No need to test wrapping with providers.

const localLogger = _logger2.mainLogger.createChild('WebMessengerController');
const onError = error => localLogger.error(new Error('TranslationsProvider fetching failed', {
  cause: error
}));
const WebMessengerController = ({
  preloadGenesysScript,
  translations
}) => {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useTranslationsWithNamespaces)();
  const {
    staticApiUrl
  } = (0, _configurationManager.useServiceUrls)(['staticApi']);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
    team: _testidGenerator.Team.Presentation,
    project: _constantsGenerated.APP_NAME,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
      logger: _logger2.mainLogger,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
        areaName: "WebMessengerController",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
          fallback: null,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ApiProvider.ApiProvider, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsProvider, {
              language: language,
              defaultTranslationsWithNamespaces: {
                [_constants.translationsNamespace]: _constants.defaultTranslations
              },
              translationsWithNamespaces: translations ? {
                [_constants.translationsNamespace]: translations
              } : undefined,
              clientFetchConfiguration: {
                tenant,
                baseUrl: staticApiUrl,
                onError
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
                namespace: _constants.translationsNamespace,
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.ExternalAuthProvider, {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_webMessengerContext.WebMessengerProvider, {
                    preloadGenesysScript: preloadGenesysScript,
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.WebMessenger, {})
                  })
                })
              })
            })
          })
        })
      })
    })
  });
};
exports.WebMessengerController = WebMessengerController;
